exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-list{background:rgba(0,0,0,.15);display:flex;flex-flow:row;flex-wrap:wrap;padding:10px}.label-list .label-item{padding:0 3px;background:hsla(0,0%,100%,.15);margin:1px;border-radius:3px;height:24px;display:flex;align-items:center}.label-list .remove-button{cursor:pointer;margin-left:2px}.label-list .add-button{background:hsla(0,0%,100%,.15);width:24px;height:22px;display:flex;align-items:center;justify-content:center;border-radius:3px;margin:1px;margin-top:3px;font-size:16px;padding-bottom:3px;cursor:pointer}.label-list input{outline:0;border:0;background:transparent;color:#fff;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7535487f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/inputs/RxLabelInput.vue
// module id = 331
// module chunks = 0